var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 40C41.8261 40 43.0979 40.5268 44.0355 41.4645C44.9732 42.4021 45.5 43.6739 45.5 45C45.5 46.3261 44.9732 47.5979 44.0355 48.5355C43.0979 49.4732 41.8261 50 40.5 50C39.1739 50 37.9021 49.4732 36.9645 48.5355C36.0268 47.5979 35.5 46.3261 35.5 45C35.5 42.225 37.725 40 40.5 40ZM0.5 0H8.675L11.025 5H48C48.663 5 49.2989 5.26339 49.7678 5.73223C50.2366 6.20107 50.5 6.83696 50.5 7.5C50.5 7.925 50.375 8.35 50.2 8.75L41.25 24.925C40.4 26.45 38.75 27.5 36.875 27.5H18.25L16 31.575L15.925 31.875C15.925 32.0408 15.9908 32.1997 16.1081 32.3169C16.2253 32.4342 16.3842 32.5 16.55 32.5H45.5V37.5H15.5C14.1739 37.5 12.9021 36.9732 11.9645 36.0355C11.0268 35.0979 10.5 33.8261 10.5 32.5C10.5 31.625 10.725 30.8 11.1 30.1L14.5 23.975L5.5 5H0.5V0ZM15.5 40C16.8261 40 18.0979 40.5268 19.0355 41.4645C19.9732 42.4021 20.5 43.6739 20.5 45C20.5 46.3261 19.9732 47.5979 19.0355 48.5355C18.0979 49.4732 16.8261 50 15.5 50C14.1739 50 12.9021 49.4732 11.9645 48.5355C11.0268 47.5979 10.5 46.3261 10.5 45C10.5 42.225 12.725 40 15.5 40ZM38 22.5L44.95 10H13.35L19.25 22.5H38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.cb7fc04880e8b48d820fd9507c313ba1.svg";
export { ForwardRef as ReactComponent };